import { EnaioParamType } from "./EnaioParamType";

export class EnaioJobParam {
    name: string;
    value: any;
    type: EnaioParamType;
}
